var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { setAuthHeader } from "../utils.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { applyWPSProxyUrl } from "../common.js";
const VNEXT_TAGS = {
  XCARD_ALERT: "XCARD_ALERT"
};
const SCORECARD_TAGS = {
  XCARD_STEP: "XCARD_STEP",
  XCARD_STEP_METADATA: "XCARD_STEP_METADATA",
  XCARD_TABLE: "XCARD_TABLE",
  XCARD_NON_EXPANDED_SEGMENTS: "XCARD_NON_EXPANDED_SEGMENTS",
  XCARD_ALERTS: "XCARD_ALERTS",
  XCARD_INSIGHTS: "XCARD_INSIGHTS",
  XCARD_INCIDENTS: "XCARD_INCIDENTS",
  XCARD_QUALITY_WARNINGS: "XCARD_QUALITY_WARNINGS",
  XCARD_AASTATUS: "XCARD_AASTATUS",
  XCARD_SCORECARD_INSIGHTS: "XCARD_SCORECARD_INSIGHTS"
};
const getXCardBaseUrl = () => {
  const prodBaseUrl = `${EnvironmentService.endpoints.legacy.url}/xcardapi`;
  const prodBaseUrlThroughFrontendProxy = EnvironmentService.endpoints.default.url;
  let baseUrl = "";
  baseUrl = EnvironmentService.useXCardThroughFEProxy() ? prodBaseUrlThroughFrontendProxy : prodBaseUrl;
  return baseUrl;
};
const getXCardUIBaseUrl = () => {
  const prodBaseUrl = EnvironmentService.callXCardApiCommonInfra() ? `${EnvironmentService.endpoints.legacy.url}/xcardapi` : `${EnvironmentService.endpoints.legacy.url}/xcard`;
  let baseUrl = "";
  baseUrl = prodBaseUrl;
  return baseUrl;
};
const vnextXCardApiBaseQuery = (args, api, extraOptions) => __async(void 0, null, function* () {
  const baseUrl = applyWPSProxyUrl(getXCardBaseUrl());
  const rawBaseQuery = fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => __async(void 0, null, function* () {
      yield setAuthHeader({ tokenScope: EnvironmentService.endpoints.default.tokenScope }, headers);
      headers.set("Cache-Control", "no-cache");
      return headers;
    })
  });
  return rawBaseQuery(args, api, extraOptions);
});
const xCardScorecardApiBaseQuery = (args, api, extraOptions) => __async(void 0, null, function* () {
  const baseUrl = applyWPSProxyUrl(getXCardUIBaseUrl());
  const rawBaseQuery = fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => __async(void 0, null, function* () {
      yield setAuthHeader({ tokenScope: EnvironmentService.endpoints.default.tokenScope }, headers);
      headers.set("Cache-Control", "no-cache");
      return headers;
    })
  });
  return rawBaseQuery(args, api, extraOptions);
});
export {
  SCORECARD_TAGS,
  VNEXT_TAGS,
  getXCardBaseUrl,
  getXCardUIBaseUrl,
  vnextXCardApiBaseQuery,
  xCardScorecardApiBaseQuery
};
//# sourceMappingURL=common.js.map
